<template>
    <div class="product">
      <!-- banner -->
      <banner title="服务体系" type='3'/>
      <!-- 导航栏 -->
      <div class="nav" v-if="width >= 1200">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane label="社区心理服务体系" name="1"></el-tab-pane>
              <el-tab-pane label="学校心理服务体系" name="2"></el-tab-pane>
              <el-tab-pane label="EAP心理服务体系" name="3"></el-tab-pane>
              <el-tab-pane label="社会工作和公益服务体系" name="4"></el-tab-pane>
          </el-tabs>
      </div>
      <div class="nav" v-if="width <= 768">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane label="社区心理服务体系" name="1"></el-tab-pane>
              <el-tab-pane label="学校心理服务体系" name="2"></el-tab-pane>
              <el-tab-pane label="EAP心理服务体系" name="3"></el-tab-pane>
              <el-tab-pane label="社会工作和公益服务体系" name="4"></el-tab-pane>
          </el-tabs>
      </div>
      <!-- 社会心理服务 -->
      <div class="society" id="society" v-if="width >= 1200">
          <div class="title">社区心理服务体系</div>
<!--          <div class="societyTop" style="cursor: pointer;">-->
<!--              <img style="border-radius: 10px" :src="socImg" alt="" @click="changeHadlers()">-->
<!--              <div class="content">{{ socSub }}</div>-->
<!--          </div>-->
<!--          <div class="societyBottom" style="cursor: pointer;">-->
<!--              <div :class="index == itemType ? 'highlight' : 'box'" v-for="(item,index) in box"-->
<!--                  :key="index" @click="societyClick(index,item.id)">-->
<!--                  <div class="line" v-if="index == itemType"></div>-->
<!--                  {{ item.mainTitle }}-->
<!--              </div>-->
<!--          </div>-->
        <el-carousel height="380px">
          <el-carousel-item v-for="item in box" style="cursor: pointer;" :key="item" @click.native="changeHadlers()">
            <img style="border-radius: 10px;object-fit: cover; width: 100%;height: 380px;object-fit: cover" :src="imgserver + item.picture" alt="" @click="alert(213123)">
            <p>{{ item.mainTitle }}</p>
          </el-carousel-item>
        </el-carousel>
      </div>


      <!-- 移动端社会心理服务 -->
      <div class="society" id="society" v-if="width <= 768">
          <div class="etitle">社区心理服务体系</div>
          <el-carousel height="160px">
            <el-carousel-item v-for="item in box" :key="item" @click.native="changeHadlers()">
                <img style="border-radius: 10px" :src="imgserver + item.picture" alt="">
                <p>{{ item.mainTitle }}</p>
            </el-carousel-item>
          </el-carousel>
      </div>
      <!-- 学校心理服务 -->
      <div class="school" id="school"  v-if="width >= 1200">
          <div class="body">
              <div class="title">学校心理服务体系</div>
              <div class="cradList" >
                  <img style="border-radius: 10px;object-fit: cover" :src="imgserver + schoolObj.picture" alt="">
                <p style="white-space:pre;" class="ql-editor ql-container ql-snow" v-html="schoolObj.subTitle"></p>
                 <div style="text-align:center;">
                      <el-button round @click="godetail(2)">了解更多</el-button>
                 </div>
              </div>
          </div>
      </div>
        <!-- 移动端学校心理服务 -->
        <div class="school" id="school" v-if="width <= 768">
          <!-- <div class="body"> -->
              <div class="etitle">学校心理服务体系</div>
              <div class="cradList" >
                  <img style="border-radius: 10px" :src="imgserver + schoolObj.picture" alt="">
                <div class="ffo">
                  <p class="ql-editor ql-container ql-snow" style="white-space:pre;" v-html="schoolObj.subTitle"></p>
                    <div style="text-align:left;font-size: 10px;color: #34A59A;margin-top:20px;font-weight:600">
                        <el-button type="text" @click="godetail(2)">了解更多</el-button>
                    </div>
                </div>
              </div>
          <!-- </div> -->
      </div>
      <!-- EAP服务 -->
      <div class="eap" id="eap"  v-if="width >= 1200">
          <div class="title">EAP服务体系</div>
<!--          <div class="societyTop" style="cursor: pointer;">-->
<!--              <img style="border-radius: 10px" :src="eapSrc" alt="" @click="changeHadler()">-->
<!--              &lt;!&ndash; <img style="width:50px;height:70px;position: absolute;right:75px;bottom:30px" src="../assets/img/right.png" alt=""> &ndash;&gt;-->
<!--              <div class="content">{{ eapSub }}</div>-->
<!--          </div>-->
<!--          <div class="societyBottom" style="cursor: pointer;">-->
<!--              <div :class="index == eapType ? 'highlight' : 'box'"-->
<!--                  v-for="(item,index) in eap" :key="index" @click="eapClick(index,item.id)">-->
<!--                  <div class="line" v-if="index == eapType"></div>-->
<!--                  {{ item.mainTitle }}-->
<!--              </div>-->
<!--          </div>-->
        <el-carousel height="380px">
          <el-carousel-item v-for="item in eap" style="cursor: pointer;" :key="item" @click.native="changeHadler()">
            <img style="border-radius: 10px;width: 100%;height: 380px;object-fit: cover;" :src="imgserver + item.picture" alt="">
            <p>{{ item.mainTitle }}</p>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 移动端EAP服务 -->
      <div class="eap" id="eap" v-if="width <= 768">
          <div class="etitle">EAP服务体系</div>
          <el-carousel height="160px">
            <el-carousel-item v-for="item in eap" :key="item" @click.native="changeHadler()">
                <img style="border-radius: 10px" :src="imgserver + item.picture" alt="">
                <p>{{ item.mainTitle }}</p>
            </el-carousel-item>
          </el-carousel>
      </div>
      <!-- 社会工作和公益服务 -->
      <div class="social" id="social" v-if="width >= 1200">
          <div class="body">
              <div class="title">社会工作和公益服务体系</div>
              <div class="cradList" >
                  <img style="border-radius: 10px;object-fit: cover" :src="imgserver + socObj.picture" alt="">
                <p style="white-space:pre;text-align: left" class="ql-editor ql-container ql-snow" v-html="socObj.subTitle"></p>
                 <div style="text-align:center;">
                      <el-button round  @click="godetail(4)">了解更多</el-button>
                 </div>
              </div>
          </div>
      </div>
      <!-- 移动端学校心理服务 -->
      <div class="school" id="school" v-if="width <= 768">
          <!-- <div class="body"> -->
              <div class="etitle">社会工作和公益服务体系</div>
              <div class="cradList" >
                  <img style="border-radius: 10px" :src="imgserver + socObj.picture" alt="">
                <div class="ffo">
<!--                    <p>{{ socObj.subTitle }}</p>-->
                  <p class="ql-editor ql-container ql-snow" style="white-space:pre;" v-html="socObj.subTitle"></p>
                    <div style="text-align:left;font-size: 10px;color: #34A59A;margin-top:20px;font-weight:600">
                        <el-button type="text" @click="godetail(2)">了解更多</el-button>
                    </div>
                </div>
              </div>
          <!-- </div> -->
      </div>
      <!-- 联系方式 -->
      <contact></contact>
    </div>
  </template>

  <script>
  import Banner from "../components/Banner";
  import Contact from "../components/contact.vue"
  import { getserviceSystem } from '../api/api'
  export default {
      data() {
          return {
              activeName:"1",
              content:`社区心理服务体系\n学校心理服务体系\nEAP心理服务体系\n社会工作和公益服务体系`,
              box:[],
              eap:[],
              itemType: 0, // 等级筛选选中的标识
              materialCode: '', // 分类的code值
              eapType: 0, // 等级筛选选中的标识
              eapCode: '', // 分类的code值


              socImg:"",
              socSub:"",
              schoolObj:{},
              eapSrc:"",
              eapSub:"",
              socObj:{},
              id:"",
              socEap:{},
              socty:{},
              width:document.body.clientWidth,


          };
      },
      components: {
          Banner,
          Contact
      },
      mounted () {

        if(this.$route.query.activeName){
          if (this.$route.query.activeName == 1) {
            setTimeout(() => {
              document.getElementById("society").scrollIntoView({ behavior: 'smooth' })
            },200)
          } else if (this.$route.query.activeName == 2){
            setTimeout(() => {
              document.getElementById("school").scrollIntoView({ behavior: 'smooth' })
            },200)
          } else if (this.$route.query.activeName == 3){
            setTimeout(() => {
              document.getElementById("eap").scrollIntoView({ behavior: 'smooth' })
            },200)
          } else if (this.$route.query.activeName == 4){
            setTimeout(() => {
              document.getElementById("social").scrollIntoView({ behavior: 'smooth' })
            },200)
          }
        }




        // let  that = this
        window.onresize = () => {
          return (() => {
            this.width = document.documentElement.clientWidth // 宽
          })()
        }
        // this.width = window.screen.width
          this.onload()
      },
      methods: {
          // 滑动到指定位置
          handleClick(tab){
              if (tab.name == 1) {
                  document.getElementById("society").scrollIntoView({ behavior: 'smooth' })
              } else if (tab.name == 2){
                  document.getElementById("school").scrollIntoView({ behavior: 'smooth' })
              } else if (tab.name == 3){
                  document.getElementById("eap").scrollIntoView({ behavior: 'smooth' })
              } else if (tab.name == 4){
                  document.getElementById("social").scrollIntoView({ behavior: 'smooth' })
              }
          },
          onload(){
              getserviceSystem().then(res => {
                  this.box = res.data.data.communityList
                  this.socImg = this.imgserver + this.box[0].picture
                  this.socSub = this.box[0].subTitle
                  this.id = this.box[0].articleId
                  this.socty = this.box[0]
                  this.schoolObj = res.data.data.school
                  this.eap = res.data.data.eapList
                  this.socEap = this.eap[0]
                  this.eapSrc = this.imgserver + this.eap[0].picture
                  this.eapSub = this.eap[0].subTitle
                  this.socObj = res.data.data.work
                //   console.log(res.data.data,'45678906');
              })
          },
          societyClick(i,id){
            // console.log(id,'iiiiid');
              this.box.forEach(item => {
                  if(item.id == id) {
                      this.socImg = this.imgserver + item.picture
                      this.socSub = item.subTitle
                      this.socty = item
                    //   console.log(this.socImg,'soc');
                    // this.id = item.articleId
                  }
              })
              this.itemType = i
              this.materialCode = id
          },
          eapClick(i,id){
              this.eap.forEach(item => {
                  if(item.id == id) {
                      this.eapSrc = this.imgserver + item.picture
                      this.eapSub = item.subTitle
                      console.log(item,'9999');
                    //   this.id = item.id
                    this.socEap = item
                  }
              })
              this.eapType = i
              this.eapCode = id
          },
          changeHadler(){
              this.$router.push({
                  path:'/productdetail',
                  query:{
                      id:this.socEap.articleId,
                      itype:3
                  }
              })
          },
          changeHadlers(){
              this.$router.push({
                  path:'/productdetail',
                  query:{
                      id:this.socty.articleId,
                      itype:1
                  }
              })
          },
          godetail(i){
              this.$router.push({
                  path:'/productdetail',
                  query:{
                      id: i == 2 ? this.schoolObj.articleId : this.socObj.articleId,
                      itype:i
                  }
              })
          },
      }
  };
  </script>

  <style lang="scss" scoped>
   @import url('../assets/font/font.css');
   * {
          margin: 0;
          padding: 0;
          font-family: Microsoft YaHei;
     font-size: 16px;
      }
      .product {
          width: 100%;
          height: 100%;
      }
      .body{
          width: 1440px;
          margin: 0 auto;
      }
      ::v-deep .el-tabs__item{
        color: #666666 !important;
    }
      //公共样式
      .title,
      .eTitle {
          font-size: 30px;
          font-weight: 700;
          line-height: 50px;
          letter-spacing: 0px;
          color: #000000;
          margin-bottom: 50px;
      }
      .eTitle {
          font-size: 30px;
          padding: 10px 0;
          font-weight: 700;
      }
      //改tab
    .nav{
        width: 100%;
        // padding: 20px 0 0 0;
        height: 50px;
        line-height: 50px;
        box-shadow: 0px 4px 10px 0px #E9F5F9;
        margin-bottom: 20px;
        box-sizing: border-box;
    }
    ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item{
        border: none !important;
        background-color: #fff !important;
        font-size: 18px;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0em;
    }
    ::v-deep .el-tabs__nav-scroll {
        width: 1440px;
        margin: 0 auto;
    }
   //结束
      ::v-deep .el-tabs--card {
          border: 0 !important;
      }
      ::v-deep .el-tabs__item .is-active{
          color: #34A59A !important;
      }
      ::v-deep .el-tabs__item:hover{
          color: #333333 !important;
      }
      ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
          background-color: #fff !important;
          color: #34A59A !important;
          border-bottom-color: transparent !important;
      }
     ::v-deep .el-tabs--card>.el-tabs__header{
          border-bottom: none !important;
     }
     ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav{
          border: none;
     }
    @media (min-width:1200px) {
          //社会心理服务
     .society{
          width: 1440px;
          box-sizing: border-box;
          padding: 50px 0;
          margin: 0 auto;
          .societyTop{
              width: 100%;
              // height: 45%;
              margin-top: 30px;
              position: relative;
              img{
                  width: 100%;
                  // height: 100%;
              }
          }
          .content{
              position: absolute;
              z-index: 100;
              bottom: 30px;
              left: 30px;
              color: #fff;
              font-size: 16px;

          }
          .societyBottom{
              width: 100%;
              font-size: 18px;
              font-weight: 500;
              line-height: 80px;
              display: flex;
              justify-content: space-around;
              .box{
                  width: 33.33%;
                  text-align: center;
                  background: #EDEEF0;
                  color: #888888;
              }
              .highlight{
                  width: 33.33%;
                  text-align: center;
                  background: #FAFAFA;
                  color: #3D3D3D;
                  margin-top: -4px
              }
              .line{
                  width: 100%;
                  height: 3px;
                  background: #34A59A;
              }
          }
     }
    //学校心理服务
    .school{
          width: 100%;
          // height: 90vh;
          box-sizing: border-box;
          padding: 50px 0;
          background: #EEF5F6;
          img{
              width: 100%;
              height: 380px;
          }
          p{
              margin-top: 40px;
            text-indent:2em;
              //text-align: center;
              // margin-bottom: 100px;
          }
          .el-button.is-round{
                  border-color: #3DCDD0;
                  color: #7fd7d8;
                  margin: 30px 0;
                  width: 100px;
                  background-color: transparent;
              }

    }
    //EAP
     .eap{
          width: 1440px;
          box-sizing: border-box;
          padding: 50px 0;
          margin: 0 auto;
          .societyTop{
              width: 100%;
              // height: 50%;
              margin-top: 30px;
              position: relative;

              img{
                  width: 100%;
                  // height: 100%;
              }
          }
          .content{
              position: absolute;
              z-index: 100;
              bottom: 30px;
              left: 30px;
              color: #fff;
              font-size: 16px;

          }
          .societyBottom{
              width: 100%;
              font-size: 18px;
              font-weight: 500;
              line-height: 80px;
              display: flex;
              justify-content: space-around;
              .box{
                  width: 50%;
                  text-align: center;
                  background: #EDEEF0;
                  color: #888888;
              }
              .highlight{
                  width: 50%;
                  text-align: center;
                  background: #FAFAFA;
                  color: #3D3D3D;
                  margin-top: -4px
              }
              .line{
                  width: 100%;
                  height: 3px;
                  background: #34A59A;
              }
          }
     }
     //社会工作
      .social{
          width: 100%;
          // height: 90vh;
          box-sizing: border-box;
          padding: 50px 0;
          background: #EEF5F6;
          img{
              width: 100%;
              height: 380px;
          }
          p{
            margin-top: 40px;
            text-indent:2em;
          }
          .el-button.is-round{
                  border-color: #3DCDD0;
                  color: #7fd7d8;
                  margin: 30px 0;
                  width: 100px;
                  background-color: transparent;
              }
      }
    }
      @media (max-width:1200px) {
        .etitle{
            font-size: 18px;
            font-weight: 600;
            line-height: normal;
            letter-spacing: 0em;
            color: #333333;
            text-align: center;
            margin-bottom: 20px;
        }
            .nav{
                width: 100%;
                //  padding: 20px 0 0 0;
                //height: 50px;
                line-height: 50px !important;
                box-shadow: 0px 4px 10px 0px #E9F5F9;
                margin-bottom: 20px;
                box-sizing: border-box;
            }
            ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item{
                border: none !important;
                background-color: #fff !important;
                font-size: 14px;
                font-weight: 600;
                line-height: normal;
                letter-spacing: 0em;
                height: 30px;
            }
            ::v-deep .el-tabs__nav-scroll {
                width: 100%;
                margin: 0 auto;
            }
            //要改成移动端
        //社会心理服务
     .society{
            width: 100%;
          box-sizing: border-box;
          padding: 30px 14px;
          margin: 0 auto;
              img{
                  width: 100%;
                  height: 160px;
                  position: relative;
                  // height: 100%;
              }
           p{
            color: #fff;
            position: absolute;
            bottom:20px;
            font-size: 14px;
            left: 20px;
           }
     }
    //学校心理服务
    .school{
          width: 100%;
        //   height: 380px;
          padding: 0 14px;
          box-sizing: border-box;
          img{
              width: 100%;
              height: 160px;
          }
          .ffo{
                padding: 10px;
              box-sizing: border-box;
              box-shadow: 0px 4px 10px 0px #E9F5F9;
          }
          p{
              text-align: left;
              font-size: 13px;
          }
        //   .el-button.is-round{
        //           border-color: #3DCDD0;
        //           color: #7fd7d8;
        //           margin: 30px 0;
        //           width: 100px;
        //           background-color: transparent;
        //       }

    }
    //EAP
     .eap{
        width: 100%;
          box-sizing: border-box;
          padding: 30px 14px;
          margin: 0 auto;
              img{
                  width: 100%;
                  height: 160px;
                  position: relative;
                  // height: 100%;
              }
           p{
            color: #fff;
            position: absolute;
            bottom:20px;
            font-size: 14px;
            left: 20px;
           }
     }
      }

  </style>
